import React, { useContext } from "react";
import MemberCard from "./BoardMemberCard";
import { InfoContext } from "./InfoContext";

const BoardMembers: React.FC = () => {
  const { boardMembers } = useContext(InfoContext);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 px-16">
      {boardMembers.map((member) => (
        <MemberCard
          key={member.mail}
          name={member.name}
          role={member.role}
          mail={member.mail}
          img_url={member.img_url}
          isActive={member.isActive}
        />
      ))}
    </div>
  );
};

export default BoardMembers;
